/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { PageDataFromId } from '@/data/types/PageDataFromId';
import { getDefaultContainerLayout } from '@/data/utils/getDefaultContainerLayout';
import { filterAuroraLayouts, replcaeAuroraWidgetsInSlots, replcaeWidgetsForHelloRetail } from './filterAuroraLayouts';
import { RUBY_SUPPORTED_AURORA_PAGE_TYPES } from '../constants/layout';

type SetDefaultLayoutProps = {
	isHelloRetailSearchEnabled?:boolean;
}

export const setDefaultLayoutIfNeeded = (pageFromId?: PageDataFromId, isB2B?: boolean, props?:SetDefaultLayoutProps) => {
	if(pageFromId && pageFromId.layout){ // check and delete if response contains layout created in commerce composer
		if(RUBY_SUPPORTED_AURORA_PAGE_TYPES.includes(pageFromId.page.type) 
		){
			if(!filterAuroraLayouts(pageFromId.layout)){
				if(pageFromId.layout.containerName==="product-listing-page"){
					//Container name is same in Commerce composer and Page composer(which is not the case for any other container) and layout designs are different.
					//Hence pages with these containers can be assigned to either of the layouts only. Therefore, redirecting the coomerce composer layouts to different container created to accommodate its design
					pageFromId.layout.containerName = "product-listing-page-aurora"; 
				}
				pageFromId.layout.slots = replcaeAuroraWidgetsInSlots(pageFromId.layout.slots);
			}
		}else if(!filterAuroraLayouts(pageFromId.layout)){
			delete pageFromId.layout;
		}
	}
	if(props?.isHelloRetailSearchEnabled && pageFromId?.layout && pageFromId.page.type==="SearchPage"){
		pageFromId.layout.slots = replcaeWidgetsForHelloRetail(pageFromId.layout.slots);
	}
	if (pageFromId && !pageFromId.layout?.id) {
		return {
			...pageFromId,
			layout: pageFromId.layout
				? Object.assign(
						pageFromId.layout,
						getDefaultContainerLayout(pageFromId as IncomingContent, isB2B)
				  )
				: getDefaultContainerLayout(pageFromId as IncomingContent, isB2B),
		};
	} else {
		return pageFromId;
	}
};
